import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { cn } from '@/lib/utils'
import SiteHeader from '@/components/generals/site-header'
import SiteFooter from '@/components/generals/site-footer'

export const Layout: FC<LayoutProps> = ({ children, footer = 'full', immersive = false }): ReactNode => {
    return (
        <div className={cn('relative flex flex-col bg-background text-foreground', immersive ? 'h-[100dvh] overflow-hidden' : 'min-h-screen')}>
            <a
                href='#main'
                className='sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[120] focus:rounded-full focus:bg-ivory focus:px-5 focus:py-3 focus:text-[11px] focus:font-medium focus:uppercase focus:tracking-[0.3em] focus:text-ink'
            >
                Skip to content
            </a>

            <SiteHeader />

            <main id='main' className='flex-1'>
                {children}
            </main>

            {footer !== 'none' && <SiteFooter variant={footer} />}
        </div>
    )
}
